export const locale___ComOverlayComponent = {
	'click_to_enable_controls': {
		de_de: 'Klicken Sie, um die Steuerung auf der Karte zu aktivieren.',
		en_us: 'Click to enable controls on the map.',
		es_es: 'Haz clic para habilitar los controles en el mapa.',
		fr_fr: 'Cliquez pour activer les contrôles sur la carte.',
		it_it: 'Clicca per abilitare i controlli nella mappa',
	},
};